const doc = [({"zh_cn":({"adminConstantPayType":({"all":"可以使用所有付款方式", "onSite":"现场支付", "prePayment":"信用卡付款"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;